<template>
  <div class="login_container">
    <div align="center">
      <br>
      <br>
      <br>
      <br>
      <br>
      <span style="font-size: 40px;color: white;">{{userComName}}订单管理系统</span>
    </div>
    <div class="login_box">
      <!-- 头像 -->
      <!-- <div class="avatar_box">
        <img src="../assets/logo.png" alt="">
      </div> -->
      <!-- 表单 -->
      <el-form ref="LoginFormRef" :model="loginForm" label-width="0" :rules="LoginFormRules" class="login_form">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入账号" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" placeholder="请输入密码" prefix-icon="el-icon-lock" type="password"></el-input>
        </el-form-item>
        <el-form-item prop="indate">
          <el-tooltip class="item" effect="light" content="登陆有效时间" placement="right">
            <el-select v-model="loginForm.indate" placeholder="请选择登陆有效时间" size="mini">
              <el-option label="1天有效" value="86400000"></el-option>
              <el-option label="7天有效" value="604800000"></el-option>
              <el-option label="30天有效" value="2592000000"></el-option>
            </el-select>
          </el-tooltip>
        </el-form-item>
        <el-form-item class="btns">
          <el-button type="primary" @click="login">登录</el-button>
          <!-- <el-button type="info" @click="resetLoginForm">重置</el-button> -->
        </el-form-item>
      </el-form>  
    </div>
    <p style="background:none;height: 5%;position: fixed;bottom: 0px;width: 100%;text-align: center;">
      <a class="banquan" style="color:white;text-decoration:none;" href="https://beian.miit.gov.cn/" target="_blank">
        京ICP备2021002612号
      </a>
    </p>
  </div>
</template>

<script>
export default {
    data() {
      return {
        userComName: window.localStorage.getItem('userComName'),
        loginForm:{
          username:'',
          password:'',
          indate: "86400000"
        },
        LoginFormRules:{
          username:[
            { required: true, message: '请输入账号', trigger: 'blur' },
          ],
          password:[
            { required: true, message: '请输入密码', trigger: 'blur' },
          ]
        }
      }
    },
    methods: {
      resetLoginForm() {
        this.$refs.LoginFormRef.resetFields()
      },
      login() {
        this.$refs['LoginFormRef'].validate(async (valid) => {
          if (valid) {
            const {data:res} = await this.$http.post('/api/user/login',this.loginForm)
            if (res.code==1){
                this.$message({
                message:res.msg,
                type:'success'
              })
              window.localStorage.setItem('token',res.data.token)
              window.localStorage.setItem('userId',res.data.user.id)
              window.localStorage.setItem('userComName',res.data.user.comName)
              window.localStorage.setItem('userComCode',res.data.user.comCode)
              window.localStorage.setItem('userCompellation',res.data.user.compellation)
              
              if(res.data.user.defPushComName == null)
              {
                window.localStorage.setItem('defPushComName',"")
              }
              else
              {
                window.localStorage.setItem('defPushComName',res.data.user.defPushComName)
              }
              
              if(res.data.user.defPushComCode == null)
              {
                window.localStorage.setItem('defPushComCode',"")
              }
              else
              {
                window.localStorage.setItem('defPushComCode',res.data.user.defPushComCode)
              }
              
              if(res.data.user.process == null)
              {
                window.localStorage.setItem('process',"")
              }
              else
              {
                window.localStorage.setItem('process',res.data.user.process)
              }
              
              window.localStorage.setItem('pagePermission',res.data.user.pagePermission)
              window.localStorage.setItem('userType',res.data.user.userType)
              //console.log(res.data.user);
              
              var redirect = this.$route.query.redirect;
              if(redirect != undefined)
              {
                this.$router.push(redirect)
              }else{
                this.$router.push('/')
              }
              
            }else{
              this.$message({
                message:res.msg,
                type:'error'
              })
            }
          } else {
            return false
          }
        })
      }
    },
    created() {
      if(this.$route.query.userInfoAlter == 1)
      {
        this.$message({
          message:"账号关键信息变更，请重新登录！",
          type:'error'
        })
      }
    }
}
</script>

<style lang="less" scoped>
.login_container{
  background-color: #2b4b6b;
  height: 100%;
}

.login_box{
  width: 500px;
  height: 320px;
  background-color: #fff;
  border-radius: 3px;
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%,-50%)
}

.avatar_box{
  width: 130px;
  height: 130px;
  border: 1px solid #eee;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left:50%;
  transform: translate(-50%,-50%);
  background-color: #fff;
  img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #eee;
  }
}

.login_form{
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.btns{
  display: flex;
  justify-content:center;
}
</style>

